import { defineComponent } from 'vue'
import type { ExtractPropTypes, PropType } from 'vue'


export const querytableColumnStringProps = () => ({
  head: String,
  headAlign: String as PropType<'left' | 'right' | 'center'>,
  bodyAlign: String as PropType<'left' | 'right' | 'center'>,
  name: String,
  width: [String, Number],
  fixed: [Boolean, String],
})

export type QuerytableColumnStringProps = Partial<ExtractPropTypes<ReturnType<typeof querytableColumnStringProps>>>

export default defineComponent({
  name: 'OQuerytableColumnString',
  inheritAttrs: false,
  props: querytableColumnStringProps(),
  setup(props, { slots, attrs, emit, expose }) {
    return () => null
  },
})
